import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

import DateInterval from "../../_common/DateInterval"


const CourseInfo = (props) => {

    const {
        startDate,
        startTime,
        endDate,
        endTime,
        workload,
    } = props


    return (
        <div className='nrt-course-info-panel'>

            {
                startDate &&
                <div>
                    <div className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
                            <path
                                d="M57 4h-7V1a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v3H19V1a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v3H3a1 1 0 0 0-1 1v54a1 1 0 0 0 1 1h54a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zM43 2h5v6h-5V2zM12 2h5v6h-5V2zM4 6h6v3a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V6h22v3a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V6h6v9H4V6zm0 52V17h52v41H4z"/>
                            <path
                                d="M38 23H11v29h38V23H38zm-7 2h7v7h-7v-7zm7 16h-7v-7h7v7zm-16-7h7v7h-7v-7zm0-9h7v7h-7v-7zm-9 0h7v7h-7v-7zm0 9h7v7h-7v-7zm7 16h-7v-7h7v7zm9 0h-7v-7h7v7zm9 0h-7v-7h7v7zm9 0h-7v-7h7v7zm0-9h-7v-7h7v7zm0-16v7h-7v-7h7z"/>
                        </svg>




                    </div>
                    <div>

                        <h3 className={'title'}>Data</h3>

                        <DateInterval startDate={startDate}
                                      startTime={startTime}
                                      endDate={endDate}
                                      endTime={endTime}/>
                    </div>
                </div>

            }

            {
                workload &&

                <div>
                    <div className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
                            <path
                                d="M30 0C13.458 0 0 13.458 0 30s13.458 30 30 30 30-13.458 30-30S46.542 0 30 0zm0 58C14.561 58 2 45.439 2 30S14.561 2 30 2s28 12.561 28 28-12.561 28-28 28z"/>
                            <path
                                d="M31 26.021V15.879a1 1 0 1 0-2 0v10.142a3.995 3.995 0 0 0-2.858 2.858H19a1 1 0 1 0 0 2h7.142c.447 1.72 2 3 3.858 3 2.206 0 4-1.794 4-4 0-1.859-1.28-3.411-3-3.858zm-1 5.858c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM30 9.879a1 1 0 0 0 1-1v-1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1zM30 49.879a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1-1zM52 28.879h-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM9 28.879H8a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM44.849 13.615l-.707.707a.999.999 0 1 0 1.414 1.414l.707-.707a.999.999 0 1 0-1.414-1.414zM14.444 44.021l-.707.707a.999.999 0 1 0 1.414 1.414l.707-.707a.999.999 0 1 0-1.414-1.414zM45.556 44.021a.999.999 0 1 0-1.414 1.414l.707.707a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-.707-.707zM15.151 13.615a.999.999 0 1 0-1.414 1.414l.707.707a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-.707-.707z"/>
                        </svg>
                    </div>
                    <div>
                        <h3 className={'title'} >Duração</h3>
                        {workload}h
                    </div>
                </div>
            }

            {/*<div>*/}
                {/*<div className="icon">*/}
                    {/*<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.757 54.757">*/}
                        {/*<path*/}
                            {/*d="M27.557 12c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7zm0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"/>*/}
                        {/*<path*/}
                            {/*d="M40.94 5.617A19.052 19.052 0 0 0 27.38 0a19.05 19.05 0 0 0-13.56 5.617c-6.703 6.702-7.536 19.312-1.804 26.952L27.38 54.757 42.721 32.6c5.755-7.671 4.922-20.281-1.781-26.983zm.159 25.814L27.38 51.243 13.639 31.4C8.44 24.468 9.185 13.08 15.235 7.031 18.479 3.787 22.792 2 27.38 2s8.901 1.787 12.146 5.031c6.05 6.049 6.795 17.437 1.573 24.4z"/>*/}
                    {/*</svg>*/}
                {/*</div>*/}
                {/*<div>text</div>*/}
            {/*</div>*/}

        </div>
    )
}

CourseInfo.propTypes = {
    startDate: PropTypes.any,
    startTime: PropTypes.any,
    endDate: PropTypes.any,
    endTime: PropTypes.any,
    workload: PropTypes.any,
}

CourseInfo.defaultProps = {}

export default CourseInfo



// WEBPACK FOOTER //
// ./src/components/_courses/CourseInfo/index.js